import { Redirect, useLocalSearchParams } from 'expo-router';

export default function LegacyTenantEditEventRedirect() {
  const { id } = useLocalSearchParams<{ id: string; tenant: string }>();
  return <Redirect href={{ pathname: '/admin/events/[id]', params: { id } }} />;
}
